import React, { useState } from "react";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";

export default function Pageination(props) {
  const [page, setPage] = useState("");

  const pgArray = Array.from(Array(props.pageSize).keys());

  return (
    <div className=" w-full flex items-center justify-center">
      <div className="flex items-center space-x-1">
        <a
          href="#"
          className="px-4 py-2 text-primary-dark bg-[#9C5FA436] rounded-[50%] w-[3.4rem] h-[3.4rem] flex items-center justify-center"
        >
          <AiOutlineRight className="text-[4rem]" />
        </a>
        {pgArray.map((i) => {
          return [
            <div
              className={
                page === i
                  ? "px-6 py-2 text-light-prim1   rounded-[50%]  hover:text-[#212121E5] cursor-pointer text-[1.3rem]"
                  : "px-6 py-2 text-gray-light2 rounded-[50%]  hover:text-[#212121E5] cursor-pointer text-[1.3rem]"
              }
              value={i}
              onClick={() => setPage(i)}
            >
              {i + 1}
            </div>,
          ];
        })}

        <a
          href="#"
          className="px-4 py-2 text-primary-dark   bg-[#9C5FA436] rounded-[50%] w-[3.4rem] h-[3.4rem] flex items-center justify-center"
        >
          <AiOutlineLeft className=" text-[4rem]" />
        </a>
      </div>
    </div>
  );
}
